<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <template>
            <a-col :md="8" :sm="12">
              <a-form-item :label="$t('teleMarket.dataDate')">
                <a-range-picker v-model="queryParam.createdTime" format="YYYY-MM-DD" />
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="8" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'orderId')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'orderId'))" v-model="queryParam.orderId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'orderNo')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'orderNo'))" v-model="queryParam.orderNo"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
<!--        <a-row :gutter="24">-->
<!--          <a-col :md="8" :sm="12">-->
<!--            <a-form-item :label="$t('teleMarket.app')">-->
<!--              <a-select v-model="queryParam.appSsid" :placeholder="$t('select')" style="width: 100%;" mode="multiple" :allowClear='allowClear'>-->
<!--                <a-select-option value="">{{ $t('teleMarket.all') }}</a-select-option>-->
<!--                <a-select-option v-for="item in apps" :value="item.appSsid">-->
<!--                  {{ item.appSsid + '/' + item.appName }}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--        </a-row>-->
        <a-row :gutter="24">
          <a-col :md="7" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
              <a-button type="primary" @click="downLoadData" icon="search" style="margin-left: 8px">{{ $t('exportFile') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :scroll="{ x: 1300 }"
        bordered>
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="form.pageNum"
          :page-size="form.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>
    </div>
  </div>
</template>
<script>
import { filterObj } from '@/utils/util';
import {payoutOrderList} from '@/webpublicapi/order';
import {mapGetters} from "vuex";
import moment from 'moment/moment'
import exportFile from '@/webpublicapi/exportFile'
const I18N_KEY = 'order.';
export default {
  name: 'payoutOrderList',
  data () {
    return {
      I18N_KEY,
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      allowClear: true,
      total: 0,
      dataSource: [],
      apps: [],// Package list
      // totalData: {},
      // Query conditions
      queryParam: {
        "createdTime": [],
        // "appSsid": [],
        "orderId": null,
        "orderNo": null,
      },
      loading: false,
      // Table header
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      fieldName: 'textCn',
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    ...mapGetters('language', ['languageStorage']),
    columns() {
      return [
        // {
        //   title: this.$t(I18N_KEY + 'id'),
        //   align: 'left',
        //   dataIndex: 'id'
        // },
        {
          title: 'JenisPermohonan(Individu / syarikat)',
          align: 'center',
          width: 100,
          dataIndex: 'applyType'
        },
        {
          title: 'NamaPemohon',
          align: 'center',
          width: 150,
          dataIndex: 'username'
        },
        {
          title: 'JenisSyarikat',
          align: 'center',
          width: 100,
          dataIndex: 'companyType'
        },
        {
          title: 'NomborPerniagaan',
          align: 'center',
          width: 100,
          dataIndex: 'businessNo'
        },
        {
          title: 'NoKp',
          align: 'center',
          width: 150,
          dataIndex: 'curp'
        },
        {
          title: 'NomborTelefon',
          align: 'center',
          width: 120,
          dataIndex: 'mobile'
        },
        {
          title: 'Bangsa(Melayu / Cina / India/ Bumiputera(Sabah/Sarawak)',
          align: 'center',
          width: 150,
          dataIndex: 'race'
        },
        {
          title: 'Jantina(Lelaki / Perempuan)',
          align: 'center',
          width: 100,
          dataIndex: 'sex'
        },
        {
          title: 'Pekerjaan',
          align: 'center',
          width: 150,
          dataIndex: 'work'
        },
        {
          title: 'Pendapatan',
          align: 'center',
          width: 150,
          dataIndex: 'workIncome'
        },
        {
          title: 'Majikan',
          align: 'center',
          width: 150,
          dataIndex: 'employer'
        },
        {
          title: 'Alamat',
          align: 'center',
          width: 200,
          dataIndex: 'address'
        },
        {
          title: 'StatusCagaran',
          align: 'center',
          width: 150,
          dataIndex: 'collateralStatus'
        },
        {
          title: 'JenisCagaran',
          align: 'center',
          width: 100,
          dataIndex: 'collateralType'
        },
        {
          title: 'NilaiCagaran',
          align: 'center',
          width: 100,
          dataIndex: 'collateralValue'
        },
        {
          title: 'TarikhPinjaman',
          align: 'center',
          width: 100,
          dataIndex: 'loanDate'
        },
        {
          title: 'PinjamanPokok',
          align: 'center',
          width: 100,
          dataIndex: 'loanPrincipal'
        },
        {
          title: 'JumlahFaedahKeseluruhan',
          align: 'center',
          width: 100,
          dataIndex: 'totalInterest'
        },
        {
          title: 'JumlahPinjamanKeseluruhan',
          align: 'center',
          width: 100,
          dataIndex: 'totalLoanAmount'
        },
        {
          title: 'KadarFaedah',
          align: 'center',
          width: 100,
          dataIndex: 'rate'
        },
        {
          title: 'TempohBayaran',
          align: 'center',
          width: 100,
          dataIndex: 'loanTerm'
        },
        {
          title: 'BakiPinjamanKeseluruhan',
          align: 'center',
          width: 100,
          dataIndex: 'totalLoanBalance'
        },
        {
          title: 'JumlahNpl',
          align: 'center',
          width: 100,
          dataIndex: 'totalNPL'
        },
        {
          title: 'Nota(PINJAMAN SELESAI / PINJAMAN SEMASA / DALAM PROSES DAPAT BALIK / DALAM TINDAKAN MAKAMAH)',
          align: 'center',
          width: 300,
          dataIndex: 'note'
        },
      ]
    },
  },
  created () {
    // this.loadBaseData();// Load telemarketer list, type list, package list
    this.loadData(1);
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    // loadBaseData() {
    //   baseData({}).then((res) => {
    //     if (res.code === 1000) {
    //       this.teleMarketUsers = res.data.seats;
    //       this.types = res.data.types;
    //       this.apps = res.data.apps;
    //       this.view = res.data.view;
    //       this.loanTypes = res.data.loanTypes;
    //     } else {
    //       this.$message.error(res.msg)
    //     }
    //   }).catch(e => {
    //     this.$message.error(e.message);
    //   })
    // },
    loadData(arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      payoutOrderList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.rows
          // this.totalData = res.data.convert
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    getQueryParams() {
      const { createdTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        payoutStartDate: createdTime && this.transformTime(createdTime[0]),
        payoutEndDate: createdTime && this.transformTime(createdTime[1]),
      }
      // console.log(this.queryParam.createdTime)
      if(this.queryParam.createdTime.length === 0) {
        data['payoutStartDate'] = ''
        data['payoutEndDate']=''
      }
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase();
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    },
    searchReset() {
      var that = this
      that.queryParam.orderNo = null
      that.queryParam.orderId = null
      that.queryParam.createdTime = []
    },
    handleReCreate(record) {
      const data = {
        account: record.account,
        type: record.type,
        dateLabel: record.dateLabel
      }
      var param = Object.assign({}, data)
      this.doCreate(filterObj(param))
    },

    getQueryParams1() {
      const { createdTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        payoutStartDate: createdTime && this.transformTime(createdTime[0]),
        payoutEndDate: createdTime && this.transformTime(createdTime[1]),
      }
      if(this.queryParam.createdTime.length === 0) {
        data['payoutStartDate'] = ''
        data['payoutEndDate']=''
      }
      return Object.assign({}, data)
    },
    downLoadData () {
      const params = this.getQueryParams1()// Query conditions
      const file = {
        fileUrl: '/api/web/webpublic/order/payoutOrderList/export?payoutStartDate=' + this.checkParam(params.payoutStartDate) + '&payoutEndDate=' + this.checkParam(params.payoutEndDate) + '&orderNo=' + this.checkParam(params.orderNo) + '&orderId=' + this.checkParam(params.orderId),
        fileName: 'payoutOrderList.xls',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    checkParam(p){
      if(p===null || p === 'null' || p === undefined || p === 'undefined') {
        return '';
      }
      return p;
    },
    checkArrayParam(p){
      if(p===null || p === 'null' || p === undefined || p === 'undefined') {
        return [];
      }
      return p;
    },
    checkType(type) {
      if(type == '8' || type == '9' || type == '23' || type == '24' || type == '15' || type == '16' || type == '25' || type == '26') {
        return true
      }
      return false;
    },
  },
  watch: {
    languageStorage: {
      handler (lang) {
        if (lang == 'en-US') {
          this.fieldName = 'textEn';
        } else if (lang == 'es') {
          this.fieldName = 'textEs';
        } else {
          this.fieldName = 'textEn';
        }
      },
      immediate: true,
    }
  },
}
</script>